import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {ToastMessageInterface} from "../../../interfaces";

@Injectable({
  providedIn: "root"
})
export class ToastsService {
  private _toasts: BehaviorSubject<Array<ToastMessageInterface>> = new BehaviorSubject<Array<ToastMessageInterface>>([]);

  public addToast(toast: ToastMessageInterface): void {
    const toasts = this._toasts.value;
    toasts.push(toast);

    this._toasts.next(toasts);
  }

  public getToastsObservable(): Observable<Array<ToastMessageInterface>> {
    return this._toasts.asObservable();
  }
}
